import styled from 'styled-components'

import { helpers } from '../../../styles/theme'
import { StatuspageImpact } from '../types'

type Props = {
	indicator?: StatuspageImpact
}

export const Indicator = styled.div<Props>`
	width: 14px;
	height: 14px;
	border-radius: 100%;
	flex-shrink: 0;
	background-color: ${({ indicator }) => {
		switch (indicator) {
			case StatuspageImpact.None:
				return helpers.color.status.operational
			case StatuspageImpact.Minor:
				return helpers.color.status.minor
			case StatuspageImpact.Major:
				return helpers.color.status.major
			case StatuspageImpact.Critical:
				return helpers.color.status.critical
			default:
				return helpers.color.text
		}
	}}
`
